'use client';

import { useInvestorQuery } from '@/hooks/use-investor-query';
import { fetchInvestorRiskMetrics } from '../api/get-investor-metrics';
import { portfolioKeys } from '@/lib/investor-keys';
import type { InvestorMetricWindow } from '@/lib/investor-analytics';
import type { InvestorRiskMetrics } from '../types/api';

export function useRiskMetrics({
  window,
  cadenceMs
}: { window?: InvestorMetricWindow; cadenceMs?: number } = {}) {
  return useInvestorQuery<InvestorRiskMetrics>({
    key: ({ address, chainId }) =>
      portfolioKeys.riskMetrics(address, chainId, window),
    fetch: ({ address, chainId }, signal) =>
      fetchInvestorRiskMetrics(address, chainId, window, signal),
    // Fixed-window fan outs (the period table) pass a slower cadence so
    // parallel rows do not trip the API rate limiter.
    cadenceMs
  });
}
